import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class CustomerDashboardService {
    
    public checkBoxSubject:Subject<any> = new Subject();

	constructor() {}

	addSitesConnectivityStatusIcons(sites, hasNOCAccessFunction = false) {
		let icons = {
			green: '/images/green-circle-map.png', // Act Intel Sites
			blue: '/images/blue-circle-map.png', // Demo Sites
			orange: '/images/orange-circle-map.png', // Smart Rebates Sites
			red: '/images/red-circle-map.png', // Sites that have been offline for more than 7 days & has NOC access function
			white: '/images/white-circle-map.png', // Non Act-Intel Sites
		};
		let blueCustomerIdsList = [240];
		const now = Date.now();
		const sevenDaysMs = 7 * 24 * 60 * 60 * 1000;
		sites.map((site) => {
			const lastConnectDate = new Date(site.newlastconnecttime * 1000);
			const offlineMoreThan7Days = now - lastConnectDate.getTime();

			if(blueCustomerIdsList.indexOf(site.customerid) > -1 || site.site_subscription_type == 'Demo') { // Demo Site
				site.icon = icons.blue;
			}
			else if (site.act_intelligent_type == 0) { // NOT Act Intel
				site.icon = icons.white;
			}
			else if(offlineMoreThan7Days > sevenDaysMs && hasNOCAccessFunction){ // Offline Site
				site.icon = icons.red;
			}
			else if(site.is_smart_rebates){ // Is Smart Rebates
				site.icon = icons.orange;
			} 
			else if (site.act_intelligent_type == 1){ // Act Intel
				site.icon = icons.green;
			}  
			
		});
		return sites;
    }
    
    setIntelligentSitesCheckbox(value) {
		this.checkBoxSubject.next(value);
	}
}